<svg viewBox="0 0 30 30" xmlns:svg="http://www.w3.org/2000/svg" id="logo">
  <line
    x1="3"
    y1="3"
    x2="27"
    y2="3"
    stroke-width="3"
    stroke="white"
    stroke-linecap="round"
  />
  <line
    x1="27"
    y1="3"
    x2="27"
    y2="27"
    stroke-width="3"
    stroke="white"
    stroke-linecap="round"
  />
  <line
    x1="3"
    y1="27"
    x2="27"
    y2="27"
    stroke-width="3"
    stroke="white"
    stroke-linecap="round"
  />
  <line
    x1="3"
    y1="3"
    x2="3"
    y2="27"
    stroke-width="3"
    stroke="white"
    stroke-linecap="round"
  />
  <circle
    cx="6"
    cy="6"
    r="3"
    stroke="white"
    stroke-width="3"
    fill="transparent"
  />
  <circle
    cx="24"
    cy="6"
    r="3"
    stroke="white"
    stroke-width="3"
    fill="transparent"
  />
  <circle
    cx="24"
    cy="24"
    r="3"
    stroke="white"
    stroke-width="3"
    fill="transparent"
  />
  <circle
    cx="6"
    cy="24"
    r="3"
    stroke="white"
    stroke-width="3"
    fill="transparent"
  />
  <circle cx="6" cy="6" r="1.5" stroke="white" stroke-width="3" fill="white" />
  <circle cx="24" cy="6" r="1.5" stroke="white" stroke-width="3" fill="white" />
  <circle
    cx="24"
    cy="24"
    r="1.5"
    stroke="white"
    stroke-width="3"
    fill="white"
  />
  <circle cx="6" cy="24" r="1.5" stroke="white" stroke-width="3" fill="white" />
</svg>

<style>
  #logo {
    width: clamp(1rem, 10vw, 6rem);
    height: clamp(1rem, 10vw, 6rem);
  }
</style>
